import winnerArchiveDetail from './Main'
import { getBaseMetaTitle } from '@/environments'

const route = {
  path: '/archive/winner/:year/:categoryName/:name',
  name: 'winnerArchiveDetail',
  meta: {
    title: `Archive - ${getBaseMetaTitle}`
  },
  component: winnerArchiveDetail
}

export default route
